import { Css_Text_16_24_To_13_18_5_tw } from '@dreamstack/feature-components/src/layout/Texts'
import { cn } from '@dreamstack/util'
import type { FunctionComponent } from 'react'

export const SimpleFieldError: FunctionComponent<
  React.PropsWithChildren<unknown>
> = ({ children }) => {
  return (
    <div
      className={cn(
        Css_Text_16_24_To_13_18_5_tw,
        'text-accentroError-full font-semibold p-px-16'
      )}
    >
      {children}
    </div>
  )
}
